<script>
  import { role$ } from '../../store'
  import { DRIVE_REPORT_SCHEME } from '../../scheme'

  import DriveReportView from '../../views/DriveReportView.svelte'
  import FireDocForm from './FireDocForm.svelte'
  import JsonEditorModal from './JsonEditorModal.svelte'

  export let report
  export let reportRef

  let fireDocForm // コンポーネント保持用
</script>

<!-- ボックスで運転日報ビューを表示 -->
<div class="box driveReportView" data-testid="driveReportBox">
  <!-- 編集ボタン -->
  <div class="upperRightCorner">
    <button
      class="button"
      data-testid="driveReportEditorEditButton"
      on:click={() => fireDocForm.open({ ref: reportRef, ...report })}
    >
      <span class="icon">
        <i class="fas fa-pencil-alt" />
      </span>
    </button>
  </div>

  <DriveReportView name="driveReportEditor" {report} />
</div>

<!-- フォームを仕込む -->
<FireDocForm
  name="driveReportForm"
  title="運転日報"
  scheme={DRIVE_REPORT_SCHEME}
  bind:this={fireDocForm}
/>

<!-- admin用 デバッグ編集機能 -->
{#if $role$ === 'admin'}
  <JsonEditorModal data={report} ref={reportRef} />
{/if}

<style>
  /* ボタンを枠なしにする */
  button {
    border: none;
    background: none;
  }

  .box.driveReportView {
    position: relative; /* 編集ボタンをボックス右上に配置できるようにするため */
    border: double;
  }

  /* 編集ボタンをボックス右上に配置 */
  .upperRightCorner {
    position: absolute;
    width: 3.25rem;
    height: 3.25rem;
    right: 0rem;
    top: 0.5rem;
  }
</style>
